import { useState, useMemo } from "react";
import { useFormikContext } from "formik";

import { DARK, LIGHT } from "constants/appModes";

export default function useLogoSection() {
  const {
    values: {
      mode,
      svgLogo,
      [LIGHT]: { pngLogo: lightPngLogo },
      [DARK]: { pngLogo: darkPngLogo },
    },
    setFieldValue,
  } = useFormikContext();

  const [error, setError] = useState(null);

  const svgFieldName = "svgLogo";
  const pngFieldName = `${mode}.pngLogo`;
  const pngLogo = mode === DARK ? darkPngLogo : lightPngLogo;

  const availableExtensions = useMemo(() => {
    const extensions = [".png"];
    if (!lightPngLogo && !darkPngLogo) {
      extensions.push(".svg");
    }
    return extensions;
  }, [lightPngLogo, darkPngLogo]);

  const validateSvgHasPath = async (file) => {
    if (!file || file.type !== "image/svg+xml") return true;
    const text = await file.text();
    return /<path[\s>]/i.test(text);
  };

  const onAddFile = async (files) => {
    setError(null);

    const file = files[0];
    if (!file) return;

    const fileType = file.type;

    if (fileType === "image/svg+xml" && !lightPngLogo && !darkPngLogo) {
      const isValid = await validateSvgHasPath(file);
      if (!isValid) {
        setError("Invalid SVG file: missing <path> element.");
      }
      await setFieldValue(svgFieldName, file);
      return;
    }

    if (fileType === "image/png") {
      await setFieldValue(pngFieldName, file);
    }
  };

  const onRemoveFile = async () => {
    setError(null);

    if (svgLogo) {
      await setFieldValue(svgFieldName, null);
      return;
    }
    if (pngLogo) {
      await setFieldValue(pngFieldName, null);
    }
  };

  return {
    availableExtensions,
    onAddFile,
    onRemoveFile,
    logo: svgLogo || pngLogo,
    error,
  };
}
